import { ChevronLeftIcon as HeroChevronLeftIcon } from '@heroicons/react/24/outline';
export const ChevronLeftIcon = HeroChevronLeftIcon;
